<div id="dds__full-screen-overlay" class="dds__overlay"></div>
<div id="{{modalId}}" tabindex="-1" class="dds__modal modal-backdrop" role="dialog" aria-hidden="true">
    <div class="dds__modal-dialog" role="document">
        <div class="dds__modal-content" >
            <div class="dds__modal-header" style="margin-top: 1rem; display: inline-flex;">
                <button role="button" style="background: none; border: none; width: 5%; cursor: pointer;" (click)="navigateUp()">
                    <svg focusable="false" style="height:25px; width: 100%; fill: #0076ce;">
                        <use xlink:href="#dds__arrow-left" />
                    </svg>  
                </button>
                <input type="text" class="dds__form-control" style="width: 50%;" placeholder="Search Directory"  [(ngModel)] = "newPath" name="filePath" id="filePath">
                <button role="button" style="background: none; border: none; width: 5%; cursor: pointer;" (click) = "querySearch()">
                    <svg focusable="false" style="height:25px; width: 100%; fill: #0076ce;">
                        <use xlink:href="#dds__search" />
                    </svg>  
                </button>
                <p style="width: 50%; margin-left: 2%; margin-right: 2%; word-break: break-all; color: var(--dell-green);" id="fileTypeMsg">Allowed extensions for File Type Code - {{fileExtensionString}}</p>
            </div>
            <button class="dds__close" data-dismiss="dds__modal" (click)="changeExtErr()" aria-label="Close">
                <span class="dds__icons dds__close-x" aria-hidden="true"></span>
            </button>
            <div class="dds__modal-body" >
                <!-- <ng-content select="[modal-body]"></ng-content> -->
                <div *ngIf="!error" class="fixTableHead" style="margin: 1rem;overflow: auto; height: 50vh;">
                    <!-- <form [formGroup]="attachmentInfoDynamicForm"> -->
                    <table  style="width: 100%;">
                        <thead>
            
                            <tr>
                                <th></th>
                              <th [appSort]="fileElementsData" data-order="asc" data-name="name" style="cursor: pointer;">File Name
                                <svg focusable="false" style="height:14px; width: 10px; fill: #0076ce;">
                                    <use xlink:href="#dds__arrow-tri-solid-stacked
                                    " />
                                </svg> 
                              </th>
                              <th [appSort]="fileElementsData" data-order="asc" data-name="lastModifiedDate" style="cursor: pointer;" data-type="date">Date Modified
                                <svg focusable="false" style="height:14px; width: 10px; fill: #0076ce;">
                                    <use xlink:href="#dds__arrow-tri-solid-stacked
                                    " />
                                </svg> 
                              </th>
                              <th [appSort]="fileElementsData" data-order="asc" data-name="size" style="cursor: pointer;">File Size
                                <svg focusable="false" style="height:14px; width: 10px; fill: #0076ce;">
                                    <use xlink:href="#dds__arrow-tri-solid-stacked
                                    " />
                                </svg> 
                              </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <div *ngFor="let attachment of t.controls; let i = index"> -->
                            <tr *ngFor="let element of fileElementsData; let i = index" style="cursor: pointer;" 
                             [class.active]="selectedIndex === i && element.isActive === true" >
                                <!-- <ng-container [formGroup]="attachment" class="form-row"> -->
                                <td>
                                    <span>
                                        <svg *ngIf="element.isFile" focusable="false" style="height:25px; width: 25px; fill: black;">
                                            <use xlink:href="#dds__doc-lines" />
                                        </svg>  
                                        <svg *ngIf="!element.isFile" focusable="false" style="height:25px; width: 25px; fill: black;">
                                            <use xlink:href="#dds__folder" />
                                        </svg>  
                                      
                                    </span>
                                </td>
                                <td (click)="navigateToFolder(element,i)">
                                    <span>
                                      
                                        {{element.name}}
                                    </span>
                                </td>
                                <td>
                                  <span>{{element.lastModifiedDate}}</span>
                                </td>
                                <td>
                                  <span>{{element.size}}</span>
                                </td>
                            <!-- </ng-container> -->
                            </tr>
                        <!-- </ng-container> -->
                        </tbody>
                    </table>
                <!-- </form> -->
                </div>   
                <div *ngIf="error">
                    <p style="text-align: center; font-weight: bold;margin: 4rem;color: var(--dell-red);">{{errorLoadingMsg}}</p>
                </div>     
            </div>
            <div class="dds__modal-footer"> 
                <!-- <ng-content select="[modal-footer]"></ng-content> -->
                <button *ngIf="!error" class="dds__btn dds__btn-primary" (click) ="onConfirm()">Confirm</button>
                <!-- <button class="dds__btn dds__btn-secondary" data-dismiss="dds__modal">Close</button> -->
                
            </div>
            <div *ngIf="invalidFileExt">
                <p style="margin-left: 1rem;margin-right: 1rem; color: var(--dell-red);">
                     Error:
                    {{currFileExt}} is not a valid extension, valid extensions is(are) {{fileExtensionString}}
                </p>
              
              </div>
        </div>
    </div>
</div>
<a #triggerContainer>
    <button [disabled]="fileTypeCode.length===0" role="button" type="button" class="dds__btn dds__btn-sm dds__btn-secondary" data-toggle="dds__modal" data-target="#fileExplorerModal" 
    style="color: black; font-size: inherit; background: #efefef; margin: 0px 4px 0px 0px;" (click) ="browse()">Choose File</button>

</a>
